var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "p",
    {
      staticClass: "fontSize text-primary-black font-normal",
      attrs: { id: "totalCounter" },
    },
    [
      _vm._v(
        _vm._s(_vm.total) +
          " " +
          _vm._s(_vm.pageName ? `${_vm.pageName}` : "in total")
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }